
import { useEffect, useCallback } from 'react';
import { useUserRoles } from '../useUserRoles';
import { useBookingsFetch } from './useBookingsFetch';
import { useBookingActions } from './useBookingActions';
import { UseBookingsResult } from './types';

// Change the re-export to explicitly use 'export type'
export type { BookingDetails } from './types';

export const useBookings = (): UseBookingsResult => {
  const { roles, isLoading: rolesLoading } = useUserRoles();
  const isAdmin = roles.isAdmin;
  
  const {
    bookings,
    setBookings,
    isLoading,
    isFetchingMore,
    error,
    hasMore,
    fetchMoreBookings,
    filterBookings,
    activeFilter,
    refreshBooking
  } = useBookingsFetch(isAdmin);

  const { cancelBooking } = useBookingActions(setBookings, activeFilter);

  // Initial load of bookings
  useEffect(() => {
    if (!rolesLoading) {
      filterBookings(activeFilter);
    }
  }, [rolesLoading, filterBookings, activeFilter]);

  return {
    bookings,
    isLoading,
    isFetchingMore,
    error,
    hasMore,
    fetchMoreBookings,
    filterBookings,
    activeFilter,
    cancelBooking,
    isAdmin,
    refreshBooking
  };
};

export default useBookings;
